export default __webpack_public_path__ + "static/media/dwebboxLogo.1875185b.png";